module.exports = __webpack_public_path__ + "img/characterAnime5.d439c5c1.png";